"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RoomsCountSelector = void 0;
var React = _interopRequireWildcard(require("react"));
var _Desktop = require("./views/Desktop");
var _Mobile = require("./views/Mobile");
var _widgetContext = require("../../context/widgetContext");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/**
 * Это generic - ui компонент, принимающий набор пропсов, среди которых value является generic-типом
 * По дефолту value V = number | string
 * Рендерит селектор комнатностей. Сейчас используется для рендеринга селектора Квартирных и ЖКшных селекторов
 * */
const RoomsCountSelector = props => {
  const {
    isDesktop,
    isMyHome
  } = React.useContext(_widgetContext.widgetContext);
  const isDesktopView = isDesktop && !isMyHome; // Для моего дома необхъодимо использовать мобильные компоненты

  const Component = isDesktopView ? _Desktop.RoomsCountSelector : _Mobile.RoomsCountSelector;
  return /*#__PURE__*/React.createElement(Component, props);
};
exports.RoomsCountSelector = RoomsCountSelector;
RoomsCountSelector.displayName = 'RoomsCountSelector';